<template>
  <nav class="transaction-nav">
    <ul class="row container">
      <li
        :key="initial"
        v-bind="item(initial)"
        class="transaction-nav__item col--2"
        v-for="({ color, initial, title, formated }) in coins"
        >

        <a
          href="#"
          :style="{ color }"
          class="transaction-nav__item-link"
          @click.prevent="SET_ACTIVE(initial)"
          >
          <Icon
            :icon="title"
            class="transaction-nav__item-icon"
            />

          <p class="transaction-nav__item-info">
            <span class="transaction-nav__item-title" v-text="initial"></span>
            <span class="transaction-nav__item-total" v-text="formated"></span>
          </p>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
  import Icon from '@/components/Icon';
  import { mapGetters, mapMutations, mapState } from 'vuex';

  export default {
    components: {
      Icon,
    },

    computed: {
      ...mapState('coins', [
        'coins',
      ]),

      ...mapGetters('coins', [
        'coin',
      ]),
    },

    methods: {
      item (initial) {
        const isActive = this.coin.initial === initial;

        if (isActive) {
          return {
            style: {
              backgroundColor: this.coin.color,
            },
            class: 'transaction-nav__item--active',
          };
        }
      },

      ...mapMutations('coins', [
        'SET_ACTIVE',
      ]),
    }
  };
</script>

<style lang="scss">
  .transaction-nav {
    color: #FFF;
    padding: 24px 0;
    background-color: #26273f;

    &__item {
      display: flex;
      border-radius: 4px;
      align-items: center;

      &:hover {
        background-color: rgba(#FFF, .1);
      }

      &--active {
        #outside {
          fill: #fff;
        }

        #inside {
          fill: currentColor;
        }
      }

      &--active & {
        &-link {
          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05);
          background-image: linear-gradient(121deg, rgba(255, 255, 255, .15), rgba(255, 255, 255, 0));
        }

        &-info {
          color: #fff;
        }

        &-total {
          color: #fff;
        }
      }

      &-link {
        width: 100%;
        height: 48px;
        display: flex;
        padding: 0 16px;
        align-items: center;
      }

      &-icon {
        svg {
          width: 29px;
          height: 32px;
        }

        margin-right: 8px;
      }

      &-info {
        display: flex;
        line-height: 1;
        font-size: 14px;
        padding-top: 1px;
        letter-spacing: 0.3px;
        flex-direction: column;
        justify-content: space-between;
      }

      &-total {
        color: #b2b8c5;
        margin-top: 1px;
        line-height: 1.14;
      }
    }
  }
</style>
